import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Wifi } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useBranding } from "../branding";
import { EDITIONS } from "./editions";

/** 22px status bar — who, where, live state. Same on every screen. */
export function StatusBar({ access }) {
  const { user } = useAuth();
  const brand = useBranding();
  const loc = useLocation();
  const [now, setNow] = useState(new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 30000); return () => clearInterval(t); }, []);
  const ed = EDITIONS.find((e) => loc.pathname === e.route || loc.pathname.startsWith(e.route + "/"));
  const where = ed ? ed.label : loc.pathname.startsWith("/cases/") ? "Case workspace" : loc.pathname.startsWith("/documents/") ? "Document viewer" : loc.pathname.startsWith("/profile") ? "My profile" : "Workspace";
  return (
    <footer className="ent-statusbar no-print" data-testid="ent-statusbar">
      <span className="font-semibold text-slate-800" data-testid="status-user">{user?.name}</span>
      <span className="ent-status-sep" /><span data-testid="status-role">{access?.ujms_roles?.[0] || user?.role || "—"}</span>
      {access?.agency?.name && <><span className="ent-status-sep" /><span data-testid="status-agency">{access.agency.name}</span></>}
      <span className="ent-status-sep" /><span data-testid="status-court">{brand.court_name}</span>
      <span className="ent-status-sep" /><span data-testid="status-where">{where}</span>
      <span className="ml-auto inline-flex items-center gap-1 text-emerald-700" data-testid="status-live"><Wifi className="w-3 h-3" /> Live</span>
      <span className="ent-status-sep" /><span className="font-mono tabular-nums" data-testid="status-clock">{now.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" })} {now.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })}</span>
    </footer>
  );
}
